import { atom, selector } from "recoil"
import MOLocation from "../../../util/MOLocation"

export const disableVideoAtom = atom<boolean>({
  key: "disableVideoAtom",
  default: !!MOLocation.getQueryParams().disableVideo
})

export const disableMediaAtom = atom<boolean>({
  key: "disableMediaAtom",
  default: !!MOLocation.getQueryParams().disableMedia
})

export const showNoVideoSubscribeScreenSelector = selector({
  key: "showNoVideoSubscribeScreenSelector",
  get: ({get}) => get(disableVideoAtom) || get(disableMediaAtom)
})